exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-modules-forms-components-ImageCheckbox-___styles__image-checkbox___2QpmR {\n  position: relative; }\n\n.src-modules-forms-components-ImageCheckbox-___styles__input___2FPo- {\n  width: 1rem;\n  height: 1rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  cursor: pointer; }\n", ""]);

// Exports
exports.locals = {
	"image-checkbox": "src-modules-forms-components-ImageCheckbox-___styles__image-checkbox___2QpmR",
	"input": "src-modules-forms-components-ImageCheckbox-___styles__input___2FPo-"
};